<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="pageTitle"
      [canGoBack]="true"
      [noBow]="true" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <form [formGroup]="form">
    <tidy-wrapper [class]="isRightSideContent ? 'right-side-scroll-enabled' : ''">
      @if (loaded) {
        <tidy-card>
          @if (!taxId) {
            <tidy-row class="field-bottom-padding">
              <tidy-select
                [icon]="'assets/svg/home-outline.svg'"
                [label]="'Property'"
                formControlName="property_id"
                [form]="form.controls.property_id"
                [items]="propertyItems"
                [submitted]="submitted"
                [errorMessage]="'Please select a property.'" />
            </tidy-row>
          }
          <tidy-row class="field-bottom-padding">
            <tidy-input
              formControlName="name"
              [form]="form.controls.name"
              [label]="'Tax Name'"
              [icon]="'assets/svg/information-circle.svg'"
              [errorMessage]="'Please enter a tax name.'"
              [submitted]="submitted" />
          </tidy-row>
          <tidy-row class="field-bottom-padding">
            <tidy-select
              [icon]="'assets/svg/list.svg'"
              [label]="'Category'"
              formControlName="category"
              [form]="form.controls.category"
              [items]="categoryItems" />
          </tidy-row>
          <tidy-row class="field-bottom-padding">
            <tidy-input
              formControlName="rate"
              [form]="form.controls.rate"
              [label]="'Tax Rate (%)'"
              [icon]="'assets/svg/calculator-outline.svg'"
              [type]="'number'"
              [errorMessage]="'Please enter a rate from 0 to 100.'"
              [submitted]="submitted" />
          </tidy-row>
          <tidy-row class="field-bottom-padding">
            <tidy-input
              formControlName="agency"
              [form]="form.controls.agency"
              [label]="'Agency'"
              [icon]="'assets/svg/business-outline.svg'" />
          </tidy-row>
          <tidy-row class="field-bottom-padding">
            <tidy-select
              [icon]="'assets/svg/calendar-outline.svg'"
              [label]="'Filing Frequency'"
              formControlName="frequency"
              [form]="form.controls.frequency"
              [items]="frequencyItems"
              [submitted]="submitted"
              [errorMessage]="'Please select a filing frequency.'" />
          </tidy-row>
          <tidy-row class="field-bottom-padding">
            <tidy-select
              [icon]="'assets/svg/calendar-outline.svg'"
              [label]="'Filing Deadline'"
              [helperText]="'Default: 20 days after the period ends'"
              formControlName="due_rule"
              [form]="form.controls.due_rule"
              [items]="dueRuleItems" />
          </tidy-row>
          <tidy-row class="field-bottom-padding">
            <tidy-input
              formControlName="portal_url"
              [form]="form.controls.portal_url"
              [label]="'Tax Portal Link'"
              [icon]="'assets/svg/globe-outline.svg'" />
          </tidy-row>
          <tidy-row class="field-bottom-padding">
            <tidy-select
              [icon]="'assets/svg/business-outline.svg'"
              [label]="'Collected by'"
              formControlName="collecting_platforms"
              [form]="form.controls.collecting_platforms"
              [items]="platformItems"
              [multiple]="true" />
          </tidy-row>
        </tidy-card>

        <tidy-error-message
          [text]="errorMessage" />

        <tidy-button
          [text]="taxId ? 'Save' : 'Add Tax'"
          [action]="boundSave"
          class="primary" />
      } @else if (errorMessage) {
        <tidy-error-message
          [text]="errorMessage" />
      }
    </tidy-wrapper>
  </form>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
